import React from 'react'
import Header from '../components/Header/Header'
import Footer from '../components/Header/Footer'
import Aboutus from '../components/Aboutcomp/Aboutus'
import './Home.css'
const Events = () => {
  return (
    <div className='main'>
        <Header/>
<Aboutus/>
        <Footer/>

    </div>
  )
}

export default Events